import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import camelCase from 'lodash/camelCase';
import GutterBottom from '../helpers/gutter-bottom';
var GUTTER_BOTTOM = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export var DEFAULT_JUSTIFY_VALUE = 'flex-start';
export var JUSTIFY_VALUES = [DEFAULT_JUSTIFY_VALUE, 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'];
var SPACINGS = [0, 0.5, 1, 1.5, 2, 2.5, 3];

var createSpacingClasses = function createSpacingClasses(themeSpacing) {
  return SPACINGS.reduce(function (acc, spacing) {
    acc["spacing-".concat(spacing)] = {
      '&&': {
        marginLeft: spacing * themeSpacing(1),
        '&:first-child': {
          marginLeft: 0
        }
      }
    };
    return acc;
  }, {});
};

var useStyles = makeStyles(function (_ref) {
  var mixins = _ref.mixins,
      spacing = _ref.spacing;
  return _objectSpread({
    root: _objectSpread({}, mixins.flex('center', 'flex-start')),
    inline: {
      display: 'inline-flex'
    },
    justifyFlexEnd: {
      justifyContent: 'flex-end'
    },
    justifyCenter: {
      justifyContent: 'center'
    },
    justifySpaceBetween: {
      justifyContent: 'space-between'
    },
    justifySpaceAround: {
      justifyContent: 'space-around'
    },
    justifySpaceEvenly: {
      justifyContent: 'space-evenly'
    }
  }, createSpacingClasses(spacing));
});
export var ContentRow = function ContentRow(props) {
  var _classNames;

  var children = props.children,
      className = props.className,
      component = props.component,
      inline = props.inline,
      gutterBottom = props.gutterBottom,
      justify = props.justify,
      spacing = props.spacing;
  var classes = useStyles({
    justify: justify
  });
  var rootClass = classNames(classes.root, className, (_classNames = {}, _defineProperty(_classNames, classes.inline, inline), _defineProperty(_classNames, classes[camelCase("justify-".concat(justify))], justify !== DEFAULT_JUSTIFY_VALUE), _classNames));
  var defaultComponent = inline ? 'span' : 'div';
  var Component = component || defaultComponent;

  var spaceOutChildren = function spaceOutChildren(child) {
    var isTextNode = typeof child === 'string';

    if (!child) {
      return child;
    }

    var spacingClass = classes["spacing-".concat(spacing)];

    if (isTextNode) {
      return React.createElement("span", {
        className: spacingClass
      }, child);
    }

    return React.cloneElement(child, {
      className: classNames(child.props.className, spacingClass)
    });
  };

  return React.createElement(GutterBottom, {
    gutterBottom: gutterBottom
  }, React.createElement(Component, {
    className: rootClass
  }, React.Children.map(children, spaceOutChildren)));
};
process.env.NODE_ENV !== "production" ? ContentRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  gutterBottom: PropTypes.oneOf([GUTTER_BOTTOM.SMALL, GUTTER_BOTTOM.MEDIUM, GUTTER_BOTTOM.LARGE]),
  inline: PropTypes.bool,
  justify: PropTypes.oneOf(JUSTIFY_VALUES),
  spacing: PropTypes.oneOf(SPACINGS)
} : void 0;
ContentRow.defaultProps = {
  component: null,
  className: null,
  gutterBottom: null,
  justify: DEFAULT_JUSTIFY_VALUE,
  inline: false,
  spacing: 0.5
};
export default ContentRow;